import React from 'react';

const formatNumberWithCommas = (number) => {
    if (number === undefined || number === null) {
        return ''; // Return an empty string if the number is undefined or null
    }
    const numStr = number.toString();
    const lastThree = numStr.substring(numStr.length - 3);
    const otherNumbers = numStr.substring(0, numStr.length - 3);
    const formattedNumber = otherNumbers !== '' ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + ',' + lastThree : lastThree;
    return formattedNumber;
};

function NumberFormatter({ number }) {
    return <span>{formatNumberWithCommas(number)}</span>;
}

export default NumberFormatter;

// Usage
// <NumberFormatter number={2327452} />
